import { Bell, BellRing, Mail, Smartphone } from "lucide-react";
import { useEffect, useState } from "react";
import { Card, Empty, cn } from "./ui";
import { api } from "../lib/api";
import { fmtDateTime } from "../lib/format";

const KIND: Record<string, string> = { reminder: "Pengingat", due: "Jatuh tempo", overdue: "Tunggakan", receipt: "Kwitansi", collection: "Tagihan AI", announcement: "Pengumuman", rollover: "Rollover", doc_sent: "Dokumen dikirim", doc_received: "Dokumen diterima", test: "Uji" };

export function NotificationHistory({ loanId }: { loanId: string }) {
  const [d, setD] = useState<any>(null);
  useEffect(() => { api.get(`/loans/${loanId}/notifications`).then((r) => setD(r.data)).catch(() => setD({ items: [], access: null })); }, [loanId]);
  if (!d) return null;
  const a = d.access;
  return (
    <Card title="Riwayat Notifikasi / Reminder Siswa" testId="notification-history-card" subtitle={a ? `Portal: ${a.email} · ${a.push_devices} HP push aktif · terakhir buka ${a.last_seen ? fmtDateTime(a.last_seen) : "belum pernah"} · ${a.terms_accepted_at ? `ketentuan disetujui ${fmtDateTime(a.terms_accepted_at)}` : "ketentuan BELUM disetujui"}` : "Siswa belum punya akses portal HP — reminder push tidak terkirim"}>
      {a && (
        <div className={cn("mb-3 rounded-lg border px-3 py-2 text-xs flex items-center gap-2", a.push_devices ? "border-emerald-300 bg-emerald-50 dark:bg-emerald-950/30" : "border-amber-300 bg-amber-50 dark:bg-amber-950/30")} data-testid="notification-device-status">
          <Smartphone className="h-4 w-4" />
          {a.push_devices ? `Notifikasi HP aktif di ${a.push_devices} perangkat.` : "Belum ada HP yang menerima push (aplikasi belum dipasang / notifikasi belum diizinkan / aplikasi dihapus). Reminder tetap dikirim via email."}
        </div>
      )}
      {!d.items.length ? <Empty text="Belum ada notifikasi terkirim ke siswa ini." /> : (
        <ul className="divide-y text-sm max-h-80 overflow-y-auto">
          {d.items.map((n: any) => (
            <li key={n.id} className="py-2" data-testid={`notification-item-${n.id}`}>
              <div className="flex items-center justify-between gap-2">
                <p className="font-semibold flex items-center gap-1.5">{n.kind === "receipt" ? <Mail className="h-3.5 w-3.5 text-emerald-600" /> : n.read ? <BellRing className="h-3.5 w-3.5 text-primary" /> : <Bell className="h-3.5 w-3.5 text-muted-foreground" />}<span className="rounded bg-muted px-1.5 text-[10px] uppercase tracking-wide">{KIND[n.kind] || n.kind}</span> {n.title}</p>
                <span className="text-xs text-muted-foreground num whitespace-nowrap">{fmtDateTime(n.created_at)}</span>
              </div>
              <p className="text-xs text-muted-foreground mt-0.5">{n.body}</p>
              <p className="text-[10px] text-muted-foreground mt-0.5">{n.read ? "✓ dibaca siswa" : "belum dibaca"}{n.push_sent != null ? ` · push ${n.push_sent}/${n.push_total}` : ""}{n.email_sent ? " · email terkirim" : ""}</p>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
